<template>
<div>
    <table>
        <thead>
            <tr>
                <th>Tipo</th>
                <th>Especificación</th>
                <th>Descripción</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Other</td>
                <td>PREFS</td>
                <td>Información para análisis de riesgo, cookie HTTP devuelto por el navegador</td>
            </tr>
            <tr>
                <td>Other</td>
                <td>Referer</td>
                <td>Cabecera HTTP estandar, contiene la dirección de la página web anterior de la que provenía el enlace a la página actual que se siguió</td>
            </tr>
        </tbody>
    </table>
</div>
</template>
<script>
export default {
    name: 'HeadersAntifraud'
}
</script>
<style lang="css" scoped>
    table {
        margin: 0px;
    }
    table tr td:nth-child(1) {
        width: 10% !important;
    }
    table tr td:nth-child(2) {
        width: 10% !important;
    }
    table tr td:nth-child(3) {
        width: 30% !important;
    }
</style>